import { formatRoute } from 'react-router-named-routes';

import * as actionTypes from '../config/actionTypes';
import axios from '../config/axios';
import * as routes from '../config/routes';

import {
  getAuthHeaders,
  manageAuthActionError,
} from '../auth/actions';
import {
  changeInputHandler,
  handleFormSubmit,
  updateFieldErrorsHandler,
} from '../common/utility';


export const onUnmount = () => {
  return {
    type: actionTypes.UNMOUNT_ACTIVITIES,
  };
};


export const toggleError = () => {
  return {
    type: actionTypes.TOGGLE_ACTIVITIES_ERROR,
  };
};


export const showError = (error) => {
  return {
    type: actionTypes.SHOW_ACTIVITIES_ERROR,
    payload: error,
  };
};


export const toggleLoading = () => {
  return {
    type: actionTypes.TOGGLE_ACTIVITIES_LOADING,
  };
};


export const activitySuccess = (type) => {
  return {
    type: actionTypes.ACTIVITY_SUCCESS,
    payload: type,
  };
};


export const shortlistAction = (token, slug) => {
  return (dispatch) => {
    const url = '/activities/activity-handler/shortlists';
    const data = { slug: slug };  // eslint-disable-line
    axios.post(url, data, getAuthHeaders(token))
      .then(() => {
        dispatch(activitySuccess('shortlists'));
      })
      .catch((error) => {
        dispatch(manageAuthActionError(error, token));
        if (error.response.status === 400) {
          dispatch(showError(error.response.data.detail));
          dispatch(toggleError());
        } else {
          dispatch(showError('Something went wrong! Please contact tech support!'));
          dispatch(toggleError());
        }
      });
  };
};


export const showActivityList = (data) => {
  return {
    type: actionTypes.SHOW_ACTIVITY_LIST,
    payload: data,
  };
};


export const getActivities = (token, type, url = null) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    let shUrl = null;
    if (!url) {
      shUrl = `/activities/get-activities/${type}`;
    } else {
      shUrl = url;
    }
    axios.get(shUrl, getAuthHeaders(token))
      .then((response) => {
        dispatch(showActivityList(response.data));
        dispatch(toggleLoading());
      })
      .catch((error) => {
        dispatch(manageAuthActionError(error, token));
        if (error.response.status === 400) {
          dispatch(showError(error.response.data.detail));
          dispatch(toggleError());
        } else {
          dispatch(showError('Something went wrong! Please contact tech support!'));
          dispatch(toggleError());
        }
        dispatch(toggleLoading());
      });
  };
};


export const showActivity = (data) => {
  return {
    type: actionTypes.SHOW_ACTIVITY,
    payload: data,
  };
};


export const getActivityItem = (token, type, slug) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    const url = `/activities/get-activity-item/${type}/${slug}`;
    axios.get(url, getAuthHeaders(token))
      .then((response) => {
        dispatch(showActivity(response.data));
        dispatch(toggleLoading());
      })
      .catch((error) => {
        dispatch(manageAuthActionError(error, token));
        if (error.response.status === 400) {
          dispatch(showError(error.response.data.detail));
          dispatch(toggleError());
        } else {
          dispatch(showError('Something went wrong! Please contact tech support!'));
          dispatch(toggleError());
        }
        dispatch(toggleLoading());
      });
  };
};


export const toggleActionLoading = () => {
  return {
    type: actionTypes.TOGGLE_ACTION_LOADING,
  };
};


export const showActionError = (error) => {
  return {
    type: actionTypes.SHOW_ACTION_ERROR,
    payload: error,
  };
};


export const deleteActivity = (token, type, id, history) => {
  return (dispatch) => {
    dispatch(toggleActionLoading());
    const url = '/activities/delete-activity';
    const data = { activity_type: type, id: id };  // eslint-disable-line
    axios.post(url, data, getAuthHeaders(token))
      .then(() => {
        history.replace(
          formatRoute(
            routes.ACTIVITIES,
            { type: type },  // eslint-disable-line
          ),
        );
      })
      .catch((error) => {
        dispatch(manageAuthActionError(error, token));
        if (error.response.status === 400) {
          dispatch(showActionError(error.response.data.detail));
        } else {
          dispatch(showActionError('Something went wrong! Please contact tech support!'));
        }
        dispatch(toggleActionLoading());
      });
  };
};


export const updateProfileInputs = (form, data) => {
  return {
    type: actionTypes.UPDATE_ACTIVITY_INPUTS,
    payload: { form: form, data: data }  // eslint-disable-line
  };
};


export const updateFieldErrors = (form, inputs, errorData) => {
  return (dispatch) => {
    const updatedInputs = updateFieldErrorsHandler(inputs, errorData);
    dispatch(updateProfileInputs(form, updatedInputs));
  };
};


export const inputChangedHandler = (event, field, form, inputs) => {
  return (dispatch) => {
    const updatedControls = changeInputHandler(
      event,
      inputs,
      field,
    );
    dispatch(updateProfileInputs(form, updatedControls));
  };
};


const formatInputs = (form, fieldData) => {
  const fields = { ...fieldData };

  if (form === 'requestForm') {
    const options = [...fields.options];
    const op = [];
    for (const o in options) {
      op.push(options[o].value);
    }
    fields.options = op;
  }
  return fields;
};


export const submitHandler = (event, form, inputs, token, type, slug) => {
  return (dispatch) => {
    dispatch(toggleActionLoading());
    const result = handleFormSubmit(event, inputs);

    if (result.formError) {
      // frontend error
      dispatch(updateProfileInputs(form, result.inputs));
      dispatch(toggleActionLoading());
    }

    if (Object.keys(result.fields).length === Object.keys(inputs).length) {
      const url = `/activities/activity-handler/${type}`;

      const fields = formatInputs(form, result.fields);
      fields.slug = slug;

      axios.post(url, fields, getAuthHeaders(token))
        .then(() => {
          dispatch(activitySuccess(type));
          dispatch(toggleActionLoading());
        })
        .catch((error) => {
          dispatch(manageAuthActionError(error, token));
          if (error.response.status === 400) {
            if (error.response.data.detail) {
              dispatch(showActionError(error.response.data.detail));
            } else {
              dispatch(updateFieldErrors(form, inputs, error.response.data));
            }
          } else {
            dispatch(showActionError('Something went wrong! Please contact tech support!'));
          }
          dispatch(toggleActionLoading());
        });
    }
  };
};


export const replyActivity = (token, type, id, reply) => {
  return (dispatch) => {
    dispatch(toggleActionLoading());
    const url = '/activities/reply-activity';
    const data = { activity_type: type, id: id, reply: reply };  // eslint-disable-line
    axios.post(url, data, getAuthHeaders(token))
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        dispatch(manageAuthActionError(error, token));
        if (error.response.status === 400) {
          dispatch(showActionError(error.response.data.detail));
        } else {
          dispatch(showActionError('Something went wrong! Please contact tech support!'));
        }
        dispatch(toggleActionLoading());
      });
  };
};



// WEBPACK FOOTER //
// ./src/activities/actions.js